import { useSelector } from 'react-redux';

export const useIsJussubClient = () => {
  const provider = useSelector(
    (state) => state.subscription?.subscription_status?.info?.provider,
  );
  const externalId = useSelector(
    (state) => state.subscription?.subscription_status?.external_id,
  );

  return provider === 'jussub' || Boolean(externalId);
};
